import { render, staticRenderFns } from "./onlineClassChart.vue?vue&type=template&id=2d22c850&scoped=true&"
import script from "./onlineClassChart.vue?vue&type=script&lang=js&"
export * from "./onlineClassChart.vue?vue&type=script&lang=js&"
import style0 from "./onlineClassChart.vue?vue&type=style&index=0&id=2d22c850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22c850",
  null
  
)

export default component.exports